import {
  REQUEST_CLIENTIFY_FILTERS,
  REQUEST_CLIENTIFY_FILTERS_SUCCEEDED,
  REQUEST_CLIENTIFY_FILTERS_FAILED,
} from './action-types';

export const reqClientifyFilters = bindingObject => ({
  type: REQUEST_CLIENTIFY_FILTERS, bindingObject,
});

export const reqClientifyFiltersSucceeded = ({
  data, pages,
}, bindingObject) => ({
  type: REQUEST_CLIENTIFY_FILTERS_SUCCEEDED,
  data,
  pages,
  bindingObject,
});
export const reqClientifyFiltersFailed = () => ({
  type: REQUEST_CLIENTIFY_FILTERS_FAILED,
});
